import Link from 'next/link'
import React from 'react'
import SeoVehicleSearch from '@/components/seo/SeoVehicleSearch'

/**
 * Components available to every SEO page's MDX.
 *
 * Element overrides keep the copy free of markup: the source is plain markdown, and
 * anything structural is applied here so all ~70 pages stay consistent.
 */
type MdxLinkProps = Omit<React.ComponentProps<'a'>, 'ref'>

const MdxLink = ({ href, children, ...rest }: MdxLinkProps) => {
  if (!href) return <a {...rest}>{children}</a>

  // Cross-links in the copy are already public Swedish URLs — the SEO pages only exist
  // in Swedish, so there is nothing to localize.
  const isInternal = href.startsWith('/')
  if (!isInternal) {
    return (
      <a href={href} rel="noopener noreferrer" target="_blank" {...rest}>
        {children}
      </a>
    )
  }

  return (
    <Link href={href} {...rest}>
      {children}
    </Link>
  )
}

const mdxComponents = {
  a: MdxLink,
  SeoVehicleSearch,
}

export default mdxComponents
